import { createReducer, on } from "@ngrx/store";
import { CrearCotizacion } from "../../Models/crearCotizacion";
import { loadCrearCotizacion, updateCotizacionResponse, updateCrearCotizacion } from "./cotizacion.action";

export interface CotizacionState {
    data: CrearCotizacion | null;
    error: string;
}

export const initialState: CotizacionState = {
    data: {
        CotizacionEnvio: {
            selected_plan: '',
            lead_id: '',
            payment_frequency: '',
            zona_circulacion: '',
            coberturasOpcionales: []
        },
        Cotizacion: {
            data: {
                asset: {
                    brand: '',
                    cylinder: '',
                    model: '',
                    owner: {
                        address: {
                            city: '',
                            country: '',
                            department: '',
                            street: ''
                        },
                        document: {
                            number: '',
                            type: ''
                        },
                        fullname: ''
                    },
                    plate: ''
                },
                plan: {
                    price: {
                        full: {
                            currency: '',
                            amount: 0,
                            formatted: ''
                        }
                    },
                    selected: {
                        Selected: ''
                    }
                },
                pre_policy_number: '',
                quote_id: ''
            }
        }
    },
    error: ''
};
export const cotizacionReducer = createReducer(initialState, 
    on(loadCrearCotizacion, (state, { data }) => ({ ...state, data })),
    on(updateCotizacionResponse, (state, { CotizacionResp }) => ({ ...state, data: state.data ? { ...state.data, Cotizacion: CotizacionResp } : state.data })),
    on(updateCrearCotizacion, (state, { upCrearCotizacion }) => ({ ...state, data: upCrearCotizacion ? upCrearCotizacion : state.data }))
);

// 